import { useEffect, useRef, useState } from 'react';

export const useDropdownDirection = (isOpen: boolean, estimatedHeight:number) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [dropdownUp, setDropdownUp] = useState(false);

    useEffect(() => {
        if (isOpen && containerRef.current) {
            const rect = containerRef.current.getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.bottom;
            setDropdownUp(spaceBelow < estimatedHeight);
        }
    }, [isOpen, estimatedHeight]);

    return { containerRef, dropdownUp };
};